import { hasInternalPermission } from "@/stores/user";
import type { MiddlewareContext } from "@/types";
import { useUserStore } from "@/stores/user";

export const hasInternalPermissionCanManageOrders = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  if (!hasInternalPermission(store, "can_manage_orders")) {
    router.push({ name: "PageRestricted" });
    return;
  }
  return next();
};
